import { render, staticRenderFns } from "./ReportAdditionalImage.vue?vue&type=template&id=fb659870&scoped=true&"
import script from "./ReportAdditionalImage.vue?vue&type=script&lang=ts&"
export * from "./ReportAdditionalImage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportAdditionalImage.vue?vue&type=style&index=0&id=fb659870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb659870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
